import { createFFmpeg, fetchFile } from '@ffmpeg/ffmpeg';

async function convert(file) {
    const ffmpeg = createFFmpeg({
        // log: true
    })

    await ffmpeg.load()
    ffmpeg.FS('writeFile', file.name, await fetchFile(file))
    await ffmpeg.run('-i', file.name, '-vcodec', 'libx264', '-r', '30', '-t', '0.33', '-pix_fmt', 'yuv420p', '-vf', 'scale=trunc(iw/2)*2:trunc(ih/2)*2', 'output.mp4')
    const data = ffmpeg.FS('readFile', 'output.mp4')

    const url = URL.createObjectURL(new Blob([data.buffer], { type: 'video/mp4' }))
    const filename = trimExtension(file.name) + '.mp4'
    return {url: url, name: filename}
}

function trimExtension(filename) {
    return filename.slice(0, (filename.lastIndexOf('.') - 1 >>> 0) + 1)
}

export default convert